import { useEffect, useState } from "react";
import * as uuid from "uuid";
import styles from "../../../../styles/size-step.module.scss";

import { Input } from "../../../components/Input";
import { Label } from "../../../components/Label";
import { Hairline } from "../../../components/Hairline";

import classNames from "classnames/bind";
import { Textarea } from "../../../components/Textarea";
import { InputSearch } from "../../../components/InputSearch";

import { Drawer } from "../../../components/Drawer";
import { Button } from "../../../components/Button";
import { Picture } from "../../../components/Icons";
import SelectIconCategory from "./SelectIconCategory";
import { Icon } from "../../../components/core/Icon";

const SelectSizeStep = ({ category, mountPayload }) => {
  const cx = classNames.bind(styles);

  const getIcon = (category) => {
    const icons = {
      pizza: "pizza-slice",
      drink: "wine-glass",
      step: "utensils",
    };

    return icons[category.mode] || icons.step;
  };

  const handle = (values) => {
    mountPayload({ sizes: values });
  };

  return (
    <>
      <SelectIconCategory mountPayload={(value) => mountPayload({ image: value })} />
      <Label>Informe o nome da categoria</Label>
      <Input
        placeholder="Nome da categoria"
        design="three"
        onChange={(e) => mountPayload({ name: e.target.value })}
        defaultValue={category.name}
      />
      {/* <Textarea
        id="desc"
        design="two"
        placeholder="Descrição"
        className="mt-20"
        onChange={(e) => mountPayload({ description: e.target.value })}
        defaultValue={category.description}
      /> */}
      <Hairline />
      <Label>Essa categoria possui tamanhos?</Label>
      <div className={styles.grid}>
        <div
          className={cx({ item: true, selected: category.sizes.length === 1 })}
          onClick={() =>
            handle([{ name: "Tamanho único", type: "size", ref_id: uuid.v4() }])
          }
        >
          <div className={styles.icons}>
            <div className={cx({ icon: true, lg: true })}>
              <Icon name={getIcon(category)} size="lg" light />
            </div>
          </div>
          <p>Tamanho único</p>
        </div>
        <div
          className={cx({ item: true, selected: category.sizes.length > 1 })}
          onClick={() =>
            handle([
              { name: "", type: "size", ref_id: uuid.v4() },
              { name: "", type: "size", ref_id: uuid.v4() },
            ])
          }
        >
          <div className={styles.icons}>
            <div className={cx({ icon: true, xs: true })}>
              <Icon name={getIcon(category)} light />
            </div>
            <div className={cx({ icon: true, sm: true })}>
              <Icon name={getIcon(category)} size="sm" light />
            </div>
            <div className={cx({ icon: true, lg: true })}>
              <Icon name={getIcon(category)} size="lg" light />
            </div>
          </div>
          <p>Vários tamanhos</p>
        </div>
      </div>
    </>
  );
};

export default SelectSizeStep;
